export function preloadVideo() {
    let $videoContainer = $("[data-media-src]");
    let $win = $(window);
    let loadCouter = 0;

    let preloadVideo = function (element) {
        let $parent = $(element).closest(".list-card");

        if ($win.width() < 768 && $parent.hasClass("hide-media-on-mobile")) {
            return;
        } else {
            let videoSrc = $(element).attr("data-media-src");
            let video = $("<video class='video-bg' preload='metadata' autoplay muted playsinline loop><source src='" + videoSrc + "' type='video/mp4'></video>");

            $(element)
                .addClass("loaded")
                .append(video);
            loadCouter++;
        }
    };

    $win.on("scroll load", function () {
        if (loadCouter < $videoContainer.length) {
            $videoContainer.each(function (i, item) {
                if (!$(item).hasClass("loaded") && $win.scrollTop() > $(item).offset().top - $win.height() * 0.88) {
                    preloadVideo(this);
                }
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/preloadVideo.js